const EVENT_TRACKING_NAME = 'MaintenanceTasks';
const EVENT_TRACKING_ACTIONS = {
  addTask: 'addTaskClicked',
  removeTask: 'removeTaskClicked',
  inputChanged: 'inputChanged',
  selectedTask: 'selectedTask',
  editTask: 'editTaskClicked',
  editTaskModal: 'editTaskModal',
  paginationChanged: 'paginationChanged',

}

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  });
}

export default function PlanFormTasksDirective() {
  return {
    restrict: 'E',
    template: require('./tasks.html'),
    scope: {
      plan: '=',
      tasks: '=?',
    },
    controller: PlanFormTasksController,
  };

  function PlanFormTasksController(
    $scope,
    $q,
    $uibModal,
    $filter,
    MaintenanceService,
    gettextCatalog,
  ) {
    'ngInject';

    $scope.selectAllToggle = function () {};
    const self = this;

    // containers for filtering and pagination
    $scope.filteredTasks = [];
    $scope.searchText = '';

    //Pagination
    $scope.currentPage = 1;
    $scope.itemsPerPage = 8;
    $scope.maxSize = 1;

    $scope.paginationChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.paginationChanged,
        currentPage: $scope.currentPage,
      })
    }

    //applyFilter searchs to tasks for anything matching the search input.
    $scope.applyFilter = function () {
      if (!$scope.tasks) return;

      if ($scope.searchText) {
        addToDataLayer({
          action: EVENT_TRACKING_ACTIONS.inputChanged,
        });
      }

      $scope.filteredTasks = $filter('filter')($scope.tasks, $scope.searchText);
    };

    $scope.predicate = 'title';
    $scope.reverse = false;

    $scope.orderBy = function (predicate) {
      if (predicate === $scope.predicate) {
        $scope.reverse = !$scope.reverse;
      } else {
        $scope.reverse = false;
      }
      $scope.predicate = predicate;
    };

    $scope.isRemoveDisabled = function () {
      return !$scope.tasks || $scope.tasks.filter((task) => task._selected).length === 0;
    };

    var deleteSelected = function () {
      $scope.errorFlag = false;
      var promiseChain = $q.when();

      function onDeletion(task) {
        return function () {
          var defer = $q.defer();

          MaintenanceService.deleteTaskInPlan($scope.plan, task).then(
            function (response) {
              return defer.resolve(response);
            },
            function (error) {
              var errorMsg = gettextCatalog.getString('An error occurred while deleting a task');
              if (error.data || error.status) {
                if (error.data.message) {
                  errorMsg = error.data.message + ' ' + error.status.toString();
                } else {
                  errorMsg += ': ' + error.status.toString();
                }
              } else {
                errorMsg += gettextCatalog.getString('. Please try again later.');
              }
              $scope.errorFlag = true;
              $scope.errorText = errorMsg;
              return defer.reject(error);
            },
          );

          return defer.promise;
        };
      }

      function onDeletionFailed() {}

      var updatedTasks = []; //Updated tasks will have all of the tasks not set for deletion

      if ($scope.plan.id) {
        for (var i = 0; i < $scope.tasks.length; i++) {
          if ($scope.tasks[i]._selected) {
            promiseChain = promiseChain.then(onDeletion($scope.tasks[i], onDeletionFailed));
          } else {
            updatedTasks.push($scope.tasks[i]);
          }
        }
      } else {
        //If we are deleting locally just assume we are good.
        $q.resolve();
      }

      $scope.tasks = updatedTasks;

      $scope.filteredTasks = $scope.tasks.slice();
      $scope.applyFilter();

      return promiseChain;
    };

    $scope.selectedTaskToggle = (task) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.selectedTask,
        selected: task?._selected,
        taskId: task?.id
      });

    }

    $scope.editTask = function (selectedTask) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.editTask,
      });
      $scope.errorFlag = false;

      function editTask(task) {
        for (var i = 0; i < $scope.tasks.length; i++) {
          if ($scope.tasks[i].id == task.id) {
            $scope.tasks[i] = task;
          }
        }
      }

      var modalInstance = $uibModal.open({
        animation: true,
        template: require('./edit.html'),
        controller: function ($scope, $uibModalInstance, MaintenanceService, task) {
          $scope._task = task;

          $scope.toolbar = [
            ['p', 'pre', 'quote'],
            ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink'],
          ];

          $scope.value = $('#some-textarea').val();

          $scope.ok = function () {
            addToDataLayer({
              action: EVENT_TRACKING_ACTIONS.editTaskModal,
              saved: true,
            })
            $uibModalInstance.close($scope._task);
          };

          $scope.cancel = function () {
            addToDataLayer({
              action: EVENT_TRACKING_ACTIONS.editTaskModal,
              cancelled: true,
            });
            $uibModalInstance.dismiss('cancel');
          };

          $scope.titleChanged = () => {
            addToDataLayer({
              action: EVENT_TRACKING_ACTIONS.editTaskModal,
              titleChanged: true,
            });
          }

          $scope.bodyChanged = () => {
            addToDataLayer({
              action: EVENT_TRACKING_ACTIONS.editTaskModal,
              bodyChanged: true,
            })
          }

          $scope.$on('$locationChangeStart', function (event, next, current) {
            $scope.cancel();
            event.preventDefault();
          });
        },
        size: 'md',
        resolve: {
          task: function () {
            return angular.copy(selectedTask);
          },
        },
      });

      modalInstance.result.then(
        function (task) {
          //If the plan already exists in the db...
          $scope.errorFlag = false;
          if ($scope.plan.id) {
            MaintenanceService.updateTaskInPlan($scope.plan, task).then(
              function (response) {
                editTask(response.data);
              },
              function (error) {
                //failed for some reason
                var errorMsg = gettextCatalog.getString(
                  'An error occurred while updating the task',
                );
                if (error.data || error.status) {
                  if (error.data.message) {
                    errorMsg = error.data.message + ' ' + error.status.toString();
                  } else {
                    errorMsg += ': ' + error.status.toString();
                  }
                } else {
                  errorMsg += gettextCatalog.getString('. Please try again later.');
                }
                $scope.errorText = errorMsg;
                $scope.errorFlag = true;
              },
            );
          }
        },
        function () {
          //Modal hasbeen canceleled...show some kind of error represnting reason why it was cancelled
        },
      );
    };

    $scope.removeSelectedButtonPressed = function () {
      addToDataLayer({
        event: EVENT_TRACKING_ACTIONS.removeTask,
      });
      //Create a giant chain of deletions for all of the tasks that we have selected
      deleteSelected().then(
        function (response) {
          //refresh();
        },
        function (response) {
          // refresh();
        },
      );
    };

    $scope.addTaskButtonPressed = function () {
      addToDataLayer({
        event: EVENT_TRACKING_ACTIONS.addTask,
      });
      $scope.errorFlag = false;

      function addTask(task) {
        if (!$scope.tasks) {
          $scope.tasks = [];
        }
        $scope.tasks.push(task);
        //update the table
        $scope.filteredTasks = $scope.tasks.slice();
        $scope.applyFilter();
      }

      var modalInstance = $uibModal.open({
        animation: true,
        template: require('./create.html'),
        controller: function ($scope, $uibModalInstance, MaintenanceService) {
          $scope.toolbar = [
            ['p', 'pre', 'quote'],
            ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink'],
          ];

          $scope._task = {};

          $scope.inputOptions = [
            {
              type: null,
              label: gettextCatalog.getString('None'),
            },
            {
              type: 'integer',
              key: 'runhours',
              label: gettextCatalog.getString('Run Hours'),
            },
            {
              type: 'integer',
              label: gettextCatalog.getString('Integer'),
            },
            {
              type: 'number',
              label: gettextCatalog.getString('Number'),
            },
            {
              type: 'boolean',
              label: gettextCatalog.getString('Checkbox'),
            },
            {
              type: 'string',
              label: gettextCatalog.getString('Text'),
            },
          ];

          //todo: this is tempory, we need to add only a notes field for now as this is to complex for end users
          $scope._task.input = {
            key: 'notes',
            type: 'string',
            inputDescription: 'Notes',
          };
          //old $scope._task.input = $scope.inputOptions[0];

          //Take the form input and put it into the correct json model for the task
          function composeTask() {
            $scope.task = {};
            $scope.task.inputs = [];
            if ($scope._task.input.type) {
              var input = {};

              input.type = $scope._task.input.type;

              $scope._task.input = $scope.inputOptions[5];

              if ($scope._task.inputDescription) {
                input.description = $scope._task.inputDescription;
              } else {
                input.description = '';
              }

              input.validationRegex = '';
              $scope.task.inputs = [input];
            } else {
              input.key = 'note';
            }

            $scope.task.title = $scope._task.title;
            $scope.task.body = $scope._task.body;
          }

          $scope.ok = function () {
            composeTask();
            $uibModalInstance.close($scope.task);
          };

          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };

          $scope.$on('$locationChangeStart', function (event, next, current) {
            $scope.cancel();
            event.preventDefault();
          });
        },
        size: 'md',
        resolve: {},
      });

      modalInstance.result.then(
        function (task) {
          //If the plan already exists in the db...
          if ($scope.plan.id) {
            $scope.loading = true;
            MaintenanceService.createTaskInPlan($scope.plan, task)
              .then(
                function (response) {
                  addTask(response.data);
                },
                function (error) {
                  //failed for some reason
                  var errorMsg = gettextCatalog.getString(
                    'An error occurred while adding the task',
                  );
                  if (error.data || error.status) {
                    if (error.data.message) {
                      errorMsg = error.data.message + ' ' + error.status.toString();
                    } else {
                      errorMsg += ': ' + error.status.toString();
                    }
                  } else {
                    errorMsg += gettextCatalog.getString('. Please try again later.');
                  }
                  $scope.errorText = errorMsg;
                  $scope.errorFlag = true;
                },
              )
              .finally(function (result) {
                $scope.loading = false;
              });
          } else {
            addTask(task);
          }
        },
        function () {
          //Modal hasbeen canceleled...show some kind of error represnting reason why it was cancelled
        },
      );
    };

    self.refresh = function () {
      if ($scope.plan && $scope.plan.id) {
        $scope.loading = true;
        MaintenanceService.getPlanTasks($scope.plan).then(
          function (response) {
            $scope.tasks = response.data || [];
            //update the table
            $scope.filteredTasks = $scope.tasks.slice();
            $scope.applyFilter();
            $scope.loading = false;
          },
          function (error) {
            /**ESD-18577  [Bug] [Maintenance Plans] 404 on maintenance Tasks
                        remove this for now. This is causing error to be displayed for the task tab
                    **/
            //var errorMsg = gettextCatalog.getString("An error occurred while retrieving tasks");
            //if (error.data || error.status) {
            //    if (error.data.message) {
            //        errorMsg = error.data.message + " " + (error.status.toString());
            //    }
            //    else {
            //        errorMsg += ": " + (error.status.toString());
            //    }
            //}
            //else {
            //    errorMsg += gettextCatalog.getString(". Please try again later.");
            //}
            //$scope.onLoadErrorText = errorMsg;
            //$scope.onLoadErrorFlag = true;
            //$scope.loading = false;
          },
        );
      }
    };

    //ON INIT
    //If the plan currently exists try and get the associated tasks

    $scope.$watch('plan', function (newVal, oldVal) {
      self.refresh();
    });
  }
}
